var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"page-header d-flex align-start justify-space-between"},[_c('page-title',{staticClass:"mb-4",attrs:{"title":_vm.$t('playlist').toString(),"sub-title":_vm.$t('playlist_sub_title').toString()}})],1),_c('div',{staticClass:"page-content"},[_c('AdSpacesPlaylist')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }